import React from "react";
import { TextField, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

const SearchFanpageForm = ({ onSearch, placeholder = "" }) => {
  return (
    <TextField
      fullWidth
      size="small"
      placeholder={placeholder}
      onChange={(e) => onSearch(e.target.value)} // Gõ đến đâu filter đến đó
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon fontSize="small" />
          </InputAdornment>
        ),
      }}
    />
  );
};

export default SearchFanpageForm;